import { request } from "./api";

export type BroadcastAudience = "all" | "premium" | "free";

export type BroadcastItem = {
  id: string;
  message: string;
  audience: BroadcastAudience;
  status: "queued" | "sending" | "done";
  total: number;
  sent: number;
  failed: number;
  createdAt: string | null;
};

export type StudentNotification = { id: string; title: string; body: string; link: string; createdAt: string | null };

export const broadcastApi = {
  send: (token: string, message: string, audience: BroadcastAudience) =>
    request<BroadcastItem>("/admin/broadcasts", { method: "POST", body: JSON.stringify({ message, audience }) }, token),
  list: (token: string) => request<{ items: BroadcastItem[] }>("/admin/broadcasts", {}, token),
  notifications: (token: string) => request<{ items: StudentNotification[] }>("/student/notifications", {}, token),
};
